import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export const animateWithGsap = (target, animationProps, scrollProps) => {
  gsap.utils.toArray(target).forEach((el) => {
    gsap.to(el, {
      ...animationProps,
      scrollTrigger: {
        trigger: el,
        toggleActions: 'play none none none',
        start: 'top 88%',
        ...scrollProps,
      },
    });
  });
};
